<template>
  <v-text-field
    @blur="onBlur"
    v-model="model"
    ref="inputRef"
    type="text"
    inputmode="decimal"
    autocomplete="off"
    :id="id"
    :name="name"
    :label="label"
    :disabled="disabled"
    required
    prefix="$"
    single-line
    color="primary"
    hide-details="auto"
    class="simulator-field__input"
    placeholder="Ej. 1.000.000…"
    :rules="rules"
  />
</template>

<script>
import { CurrencyInputOptions, useCurrencyInput } from "vue-currency-input";
import { watch } from "@vue/composition-api";

export default {
  name: "CurrencyInput",
  props: {
    value: Number,
    options: CurrencyInputOptions,
    rules: {
      type: Array,
      default: () => [],
    },
    label: String,
    disabled: false,
    id: String,
    name: String,
  },
  data() {
    return {
      model: this.value,
    };
  },
  methods: {
    onBlur() {
      this.$emit("blur", this.model.replace(/[^0-9.]/g, ""));
    },
  },
  setup(props) {
    const { inputRef, setValue, formattedValue } = useCurrencyInput(
      props.options
    );
    watch(
      () => props.value,
      () => setValue(props.value)
    );
    return { inputRef };
  },
};
</script>
<style lang="scss">
.simulator-field__input {
  margin-top: 0 !important;
  padding-top: 0 !important;

  .v-input__slot {
    min-height: 40px !important;
  }

  .v-text-field__prefix,
  input {
    color: #00205b !important;
    font-family: "HelveticaNeue-Medium", "Roboto-Medium", sans-serif;
    font-size: 1.5rem !important;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
    line-height: 1.2;
  }

  .v-text-field__prefix {
    opacity: 1;
    padding-right: 4px;
  }
}

@media (max-width: 600px) {
  .simulator-field__input .v-text-field__prefix,
  .simulator-field__input input {
    font-size: 1.375rem !important;
  }
}
</style>
